<template>
  <div class="body-div">
    <div class="top-div">
      <div class="table">
        <table
          v-if="callsMissedAmount[time] > 0"
          v-for="time in Object.keys(callsMissed)"
          v-bind:key="time"
        >
          <thead>
            <tr class="text-center">
              {{
                GetTimeText(time)
              }}
              |
              {{
                callsMissedAmount[time]
              }}
            </tr>
          </thead>
          <tbody>
            <table v-for="user in callsMissed[time]" :key="user.id">
              <tr>
                <td>
                  {{
                    salesPersonList.find(item => item.id === user.id).full_name
                  }}
                  | {{ user.amount }}
                </td>
              </tr>
            </table>
          </tbody>
        </table>
      </div>

      <loader
        class="loader"
        :size="'8px'"
        v-if="
          callsMissedBusy[0] ||
            callsMissedBusy[1] ||
            callsMissedBusy[30] ||
            callsMissedBusy[90]
        "
      ></loader>
    </div>
    <div class="bottom-div" v-if="false">
      <span v-if="false"
        >Forbidden, You are not authorized to see this data</span
      >

      <loader :size="'11px'" v-if="callsMissedBusy"></loader>

      <div class="fab"><span class="fas fa-file-csv"></span></div>
    </div>
  </div>
</template>

<script>
import Loader from "../../../../../main/misc.main/loader/Loader";
import {mapGetters, mapState} from "vuex";
import apiClientCreator from "../../../../../helpers/api/request";
export default {
  name: "ScheduledCallsMissed.container",
  components: { Loader },
  data() {
    return {
      callsMissedBusy: {
        0: false,
        1: false,
        30: false,
        90: false
      },
      callsMissed: {
        0: [],
        1: [],
        30: [],
        90: []
      },
      callsMissedAmount: {
        0: 0,
        1: 0,
        30: 0,
        90: 0
      }
    };
  },
  computed: {
    ...mapState("user", ["auth"]),
    ...mapState("clients", [ "dictionaries", "salesPersonList"])
  },
  created() {
    this.getMissedScheduledCallsByTimeFrame(0);
    this.getMissedScheduledCallsByTimeFrame(1);
    this.getMissedScheduledCallsByTimeFrame(30);
    this.getMissedScheduledCallsByTimeFrame(90);
  },
  methods: {
    async getMissedScheduledCallsByTimeFrame(timeFrame) {
      if (
        !this.callsMissedBusy[timeFrame] &&
        this.checkPermissions(this.auth, [1, 2, 3, 4, 12])
      ) {
        try {
          this.callsMissedBusy[timeFrame] = true;
          const res = await apiClientCreator(
            `reports/scheduled_calls/missed/${timeFrame}`
          ).get("");
          this.callsMissed[timeFrame] = res.data.missed;
          this.callsMissedAmount[timeFrame] = res.data.total;
          this.callsMissedBusy[timeFrame] = false;
        } catch (e) {}
      }
    },
    checkPermissions(user, permitted) {
      return permitted.some(role => role === user.user.role);
    },
    GetTimeText(time) {
      if (time === "0") return "Today";
      if (time === "1") return "Yesterday";
      else return "Last " + time + " days";
    }
  }
};
</script>

<style scoped>
.body-div {
  padding: 4px 5px 1px 5px;
}
.top-div {
  width: 100%;
  height: max-content;
  margin: auto;
  background: white;
  border-radius: 3px;
  padding: 5px;
}
.bottom-div {
  width: 100%;
  height: 650px;
  overflow-y: scroll;
  margin: 5px auto;
  background: white;
  border-radius: 3px;
  padding: 5px;
  position: relative;
}
.fab {
  background-color: transparent;
  padding: 0;
  font-size: 30px;
  line-height: 30px;
  color: green;
  text-align: center;
  position: absolute;
  right: 10px;
  bottom: 10px;
  border-radius: 20%;
  transition: all 0.1s ease-in-out;
  cursor: pointer;
}

.fab:hover {
  box-shadow: 0 5px 11px 0 #666;
  transform: scale(1.05);
}
.table {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 20px;
}
.table td {
  padding: 0.3em 0;
}
.table table {
  font-size: 13px;
  width: 1500px;
  margin: 3em 0;
}
.table thead {
  border-bottom: solid 2px #eff3f6;
}
.table tfoot {
  border-top: solid 2px #eff3f6;
  color: red;
}
.table th {
  text-align: center;
}
.text-center {
  font-weight: bold;
}
.loader {
  left: 0;
  right: 0;
}
</style>
